import { Outlet, useRouter } from "@tanstack/react-router";
import { useCallback, useState } from "react";
import { AppFooter } from "@/components/layout/AppFooter";
import { MobileNavDrawer } from "@/components/layout/MobileNavDrawer";
import { MobileShellLayout } from "@/components/layout/MobileShellLayout";
import { resolvePbosRole } from "@/components/layout/nav-items";
import { TopNavBar } from "@/components/layout/TopNavBar";
import { useNotifications } from "@/hooks/use-notifications";
import { useVersion } from "@/hooks/use-version";
import { signOut, useSession } from "@/lib/auth-client";

export function PbosDashboardLayout() {
  const { data: session } = useSession();
  const role = resolvePbosRole(session?.user?.role);

  if (role === "contractor" || role === "supervisor") {
    return <MobileShellLayout role={role} />;
  }

  return <TopNavShellLayout />;
}

function TopNavShellLayout() {
  const { data: session } = useSession();
  const { data: notificationList } = useNotifications();
  const { data: versionData } = useVersion();
  const router = useRouter();

  const role = resolvePbosRole(session?.user?.role);
  const unreadCount = notificationList?.filter((n) => !n.read).length ?? 0;

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSignOut = useCallback(async () => {
    await signOut();
    router.navigate({ to: "/login" });
  }, [router]);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <TopNavBar
        role={role}
        userName={session?.user?.name}
        userEmail={session?.user?.email}
        userRoleLabel={session?.user?.role}
        unreadCount={unreadCount}
        onMobileMenu={() => setMobileOpen(true)}
        onSignOut={handleSignOut}
      />

      <MobileNavDrawer open={mobileOpen} onOpenChange={setMobileOpen} role={role} />

      <main className="flex-1 overflow-y-auto bg-background p-3 md:p-6">
        <Outlet />
      </main>

      <AppFooter version={versionData?.version} />
    </div>
  );
}
